// removed by extract-text-webpack-plugin
module.exports = {"root":"_3bonPHFpKiLVtVXvm6usbJ","label":"_3C5ffC9Kz7BeUCgqLBE3G0","checkbox":"_6Z0yreSG994GZmozBw1ps"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/switch-button.scss
// module id = 1180
// module chunks = 0